import { axios } from '../util/axios'
import platform from '../util/platform'

const API_ENDPOINT_V4_SEND = '/v4/pincode/send'
const API_ENDPOINT_V4_CHECK = '/v4/pincode/check'
const API_EMAIL_CHANGE_SEND_PINCODE = 'https://email-changer.olx.com.br/activate/send-pincode'
const API_EMAIL_CHANGE_CHECK_PINCODE = 'https://email-changer.olx.com.br/public/activate/pincode'
const API_CONFIRMATION_CHECK_PINCODE = '/v0/validation/pincode/check'

export const sendPinCode = (key, type, token) => {
  const bodyRequest = { platform, type }

  if (key) bodyRequest.key = key

  const config = {
    withCredentials: true,
  }

  if (token) {
    config.headers = {
      Authorization: token,
    }
  }

  return axios.post(API_ENDPOINT_V4_SEND, bodyRequest, config)
}

export const checkPinCode = (key, type, code, issuer, token) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  const bodyRequest = { platform, type, code, issuer, attemptsCheck: true }

  if (key) bodyRequest.key = key

  return axios.post(API_ENDPOINT_V4_CHECK, bodyRequest, {
    headers: {
      Authorization: token,
    },
    withCredentials: true,
  })
}

export const emailChangeSendPinCode = (newEmail, token) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  return axios.post(
    API_EMAIL_CHANGE_SEND_PINCODE,
    { newEmail },
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    }
  )
}

export const emailChangeCheckPinCode = (code, newEmail, token, requestId) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  return axios.post(
    API_EMAIL_CHANGE_CHECK_PINCODE,
    { code, newEmail, requestId },
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    }
  )
}

export const confirmationSendPinCode = (key, type, token) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  const bodyRequest = { platform, type, issuer: 'AccountsValhallaRevalidation' }

  if (key) bodyRequest.key = key

  return axios.post(API_ENDPOINT_V4_SEND, bodyRequest, {
    headers: {
      Authorization: token,
    },
    withCredentials: true,
  })
}

export const confirmationCheckPinCode = (code, token, type) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  const bodyRequest = { platform, code, token, type }

  return axios.post(API_CONFIRMATION_CHECK_PINCODE, bodyRequest, {
    withCredentials: true,
  })
}
